module.exports = __webpack_public_path__ + "img/collar_topline_length.57d0e7e1.png";